import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SystemStatusService } from '../system-status.service';

export const maintenanceGuard: CanActivateFn = (_route, state) => {
  const status = inject(SystemStatusService);
  const router = inject(Router);

  if (!status.isMaintenance()) {
    return true;
  }

  const path = state.url.split('?')[0]?.trim() ?? '';
  if (path === '/maintenance') {
    return true;
  }

  return router.parseUrl('/maintenance');
};
